import React, { Component } from "react";
import { Image, Button } from "react-bootstrap";
import DL from "./DL.png";

export default class Rekysuccuess extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div>
        <div className="row widget_BG widget_BG_grid d-flex m-0 mt-2 ">
          <div className="col text-center">
            <div className="widget_BG widget_BG_grid mb-2 justify-content-md-center ">
              <Image
                src={DL}
                className="navbar-brand pe-3 ps-4 ps-lg-2"
                alt=""
                style={{
                  width: "auto",
                  height: "50px",
                  marginBottom: "5px",
                }}
              />
              <p>
                If you want to fetch ant recent changes made in your KYC
                document please Continue
              </p>
            </div>
            <div className="col text-center">
              <Button>Continue</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
